import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import { ReactComponent as CloseIcon } from "../../Assets/close.svg";
import { CMCloseButton } from "../place-bid/place-bid/place-bid.styles";
import { TableContainer } from "@mui/material";
import { StyledTable } from "../../Pages/Public/billing-history/billing-history.styles";
import { ErrorMessage, Field, Form, Formik } from "formik";
import {
  addManualDeposit,
  getAdminBankDetails,
} from "../../Services/prod/auth.service";
import { toast } from "react-toastify";
import Button from "../button/button.component";
import * as Yup from "yup";
import { CameraIcon } from "../../Assets/svgIcons";
import pdf from "../../Assets/pdf1.png";
import Loading from "../loading/loading.component";
import { getAuthMapping } from "../../Utils/authmapping.utils";
import { formatCommaNumbers } from "../../Utils/common.utils";
import {
  customStylesDeposit,
  Title,
} from "../../Pages/RegisteredTrader/add-funds/add-funds.styles";

function MethodModal({ show, setShow, setHandleOpen, amount, data }) {
  const localStorageData = getAuthMapping();
  const [loading, setLoading] = useState(false);
  const [bankDetails, setBankDetails] = useState({});
  const [loadingBank, setLoadingBank] = useState(false);

  //  ==================== Manual Deposit  Schema ====================
  const manualDepositSchema = Yup.object({
    transactionImage: Yup.string().required("Transaction Image is Required"),
    transactionId: Yup.string()
      .required("Transaction ID is Required")
      .matches(/^\S*$/, "Transaction ID cannot contain spaces")
      .min(1)
      .max(20, "Transaction Id should have a maximum length of 20 characters"),
    remarks: Yup.string()
      .matches(/^\S.*$/, "Transaction ID cannot start with a space")
      .min(5, "Remarks should have a minimum length of 5 characters")
      .max(100, "Remarks should have a maximum length of 100 characters"),
  });

  // ==================== Manual Deposit Submit ====================
  const manualDepositSubmit = async (values) => {
    try {
      console.log(values, "valuesvalues");
      if (values) {
        const manualDepositPayload = {
          amount: amount,
          currency: "USD",
          remark: values?.remarks,
          mode_of_payment: values?.paymentMode,
          transaction_id: values?.transactionId,
          transaction_proof: values?.transactionImage,
        };
        const manualDepositRes = await addManualDeposit(manualDepositPayload);
        if (
          manualDepositRes?.status === 200 ||
          manualDepositRes?.status === 201
        ) {
          toast.success(manualDepositRes?.message);
          setShow(false);
          setHandleOpen(false);
        } else {
          toast.error(manualDepositRes?.message);
        }
      } else {
        console.log("********* MISSING IN VALUES *********");
      }
    } catch (error) {}
  };

  // ==================== UPLOAD INFLUENCER IMAGE ====================
  const handleImage = async (e, formik) => {
    try {
      const file = e.target.files[0];
      // =========== VALIDATION EXTENSION ALLOWED JPG ,JPEG, PNG  ===========
      const allowedTypes = [
        "image/jpeg",
        "image/jpg",
        "image/png",
        "application/pdf",
      ];
      if (!allowedTypes.includes(file.type)) {
        toast.error(
          `Invalid file type. Allowed types are: ${allowedTypes
            .map((type) => type.split("/")[1])
            .join(", ")}.`
        );
        return;
      }

      // ### VALIDATION SIZE ALLOWED 5 MB ####
      const maxFileSizeMB = 5;
      const maxFileSizeBytes = maxFileSizeMB * 1024 * 1024;
      if (file.size > maxFileSizeBytes) {
        toast.error(`File size exceeds the ${maxFileSizeMB}MB limit.`);
        return;
      }

      const formDataNew = new FormData();
      formDataNew.append("file", file);
      setLoading(true);
      const response = await fetch(
        `${process.env.REACT_APP_STAGE_API_URL}users/v1/user/upload-influencer-profile-image`,
        {
          method: "POST",
          headers: { Authorization: `Bearer ${localStorageData?.accessToken}` },
          body: formDataNew,
        }
      );
      if (!response.ok) {
        setLoading(false);
        throw new Error(`Error: ${response.status} ${response.statusText}`);
      }
      const data = await response.json();
      if (data?.status === 200) {
        formik.setFieldValue("transactionImage", data?.data?.image_url || "");
        setLoading(false);
      }
      return data;
    } catch (error) {
      setLoading(false);
      console.error("API fetch error:", error.message);
    }
  };

  // ************* --> ADMIN  BANK  DETAILS  API <-- *************
  const getBankDetails = async () => {
    setLoadingBank(true);
    try {
      const resBankDetails = await getAdminBankDetails(data?.id);
      if (resBankDetails?.status === 200 || resBankDetails?.status === 201) {
        setBankDetails(resBankDetails?.data);
        setLoadingBank(false);
      } else {
        console.log("API ERROR");
        setLoadingBank(false);
      }
    } catch (error) {
      setLoadingBank(false);
      console.log(error, "error");
    }
  };
  useEffect(() => {
    getBankDetails();
  }, []);
  return (
    <>
      <Modal
        isOpen={show}
        onRequestClose={() => setShow(false)}
        style={customStylesDeposit}
        contentLabel="Example Modal"
      >
        <CMCloseButton onClick={() => setShow(false)}>
          <CloseIcon width={16} height={16} />
        </CMCloseButton>
        {loadingBank ? (
          <Loading />
        ) : (
          <>
            <Title className="title">
              <h2>{data?.name}</h2>
            </Title>
            <TableContainer>
              <StyledTable border="1">
                <thead>
                  <tr style={{ fontWeight: "normal !import" }}>
                    <th>Account Number</th>
                    <th>Swift Code</th>
                    <th>Country</th>
                    <th>State</th>
                    <th>City</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{bankDetails?.bank_account_number || "N/A"}</td>
                    <td>{bankDetails?.swift_code || "N/A"}</td>
                    <td>{bankDetails?.bank_country || "N/A"}</td>
                    <td>{bankDetails?.bank_state || "N/A"}</td>
                    <td>{bankDetails?.bank_city || "N/A"}</td>
                  </tr>
                </tbody>
              </StyledTable>
            </TableContainer>
            <p style={{ textAlign: "left" }}>
              <strong>Amount</strong> - ${formatCommaNumbers(amount)}
            </p>
            <Formik
              initialValues={{
                transactionImage: "",
                transactionId: "",
                remarks: "",
                paymentMode: data?.name,
              }}
              validationSchema={manualDepositSchema}
              onSubmit={manualDepositSubmit}
              validateOnChange
              enableReinitialize
            >
              {(formik) => {
                return (
                  <Form>
                    <div className="manual_deposit_modal_form">
                      <div className="profile_img_uploader">
                        <h3>
                          Transaction Image{" "}
                          <span
                            style={{
                              color: "rgb(168, 0, 0)",
                              "margin-left": "5px",
                            }}
                          >
                            *
                          </span>
                        </h3>
                        <h5>Supported formats: (JPG, PNG, PDF)</h5>
                        {loading ? (
                          <label className="loading_label">
                            <Loading />
                          </label>
                        ) : (
                          <label>
                            {formik?.values?.transactionImage ? (
                              <>
                                {formik?.values?.transactionImage.endsWith(
                                  ".pdf"
                                ) ? (
                                  <>
                                    <img src={pdf} alt="profile" />
                                  </>
                                ) : (
                                  <img
                                    src={formik?.values?.transactionImage}
                                    alt="profile"
                                  />
                                )}
                                <button
                                  onClick={() =>
                                    formik.setFieldValue("transactionImage", "")
                                  }
                                  className="cros_btn"
                                >
                                  X
                                </button>
                              </>
                            ) : (
                              <>
                                <input
                                  type="file"
                                  onChange={(e) => handleImage(e, formik)}
                                />
                                <span>
                                  <CameraIcon />
                                </span>
                                Photo
                              </>
                            )}
                          </label>
                        )}
                        <ErrorMessage
                          name="transactionImage"
                          component="div"
                          className="error"
                        />
                      </div>
                      <div className="input_design">
                        <div>
                          <h3>
                            Transaction ID{" "}
                            <span
                              style={{
                                color: "rgb(168, 0, 0)",
                                "margin-left": "5px",
                              }}
                            >
                              *
                            </span>{" "}
                          </h3>
                          <div>
                            <Field
                              type="text"
                              name="transactionId"
                              placeholder="Enter The Transaction ID"
                            />
                            <ErrorMessage
                              name="transactionId"
                              component="div"
                              className="error"
                            />
                          </div>
                        </div>
                        <div>
                          <h3>Remarks </h3>
                          <div>
                            <Field
                              type="text"
                              name="remarks"
                              placeholder="Enter Remarks"
                            />
                            <ErrorMessage
                              name="remarks"
                              component="div"
                              className="error"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    {loading ? (
                      "Loading.."
                    ) : (
                      <Button type="submit" disabled={loading}>
                        Continue
                      </Button>
                    )}
                  </Form>
                );
              }}
            </Formik>
          </>
        )}
      </Modal>
    </>
  );
}

export default MethodModal;
